import { truncateLabel } from "../utils";

import { FilterBase } from "./FilterBase";
import styles from "./FilterOptions.module.css";

interface FilterMultiSelectOptionsProps {
  label: string;
  options: {
    label: string;
    value: string | string[];
    key?: string;
    frequency?: number;
  }[];
  values: number[]; // <-- now array of indices
  onChange: (val: number[]) => void;
  onClear?: () => void;
  onApply: () => void;
  isQuestionnaire?: boolean;
  subtitle?: string;
  optionsVariant?: "wrap" | "grid";
  onDismiss?: () => void;
  max?: number;
  min?: number;
}

export const FilterMultiSelectOptions = ({
  options,
  values = [],
  onChange,
  onClear,
  onApply,
  isQuestionnaire = true,
  label,
  subtitle,
  optionsVariant = "wrap",
  onDismiss,
  max,
  min,
}: FilterMultiSelectOptionsProps) => {
  const toggle = (idx: number) => {
    const isSelected = values?.includes(idx);
    const newValues = isSelected
      ? values.filter((a) => a !== idx)
      : [...(values || []), idx];
    onChange(newValues);
  };

  return (
    <FilterBase
      title={truncateLabel(label)}
      onClear={onClear}
      onApply={onApply}
      disableClear={!values || values.length === 0}
      disableApply={
        ((!values || values.length === 0) && (min === undefined || min > 0)) ||
        (!!max && values.length > max) ||
        (!!min && values.length < min)
      }
      isQuestionnaire={isQuestionnaire}
      subtitle={subtitle ? truncateLabel(subtitle) : subtitle}
      onDismiss={onDismiss}
    >
      <section
        className={
          optionsVariant === "grid" ? styles.optionsGrid : styles.optionsWrap
        }
      >
        {options?.length &&
          options.map((item, idx) => {
            const isSelected = values?.includes(idx);
            const isDisabled =
              !isSelected && typeof max === "number" && values.length >= max;
            const frequency = (item.frequency ?? 0) + 1 || 1; // PATCH: ensure frequecy is never 0 TODO: Use frequency once IN-1056 is resolved
            // const frequency = item.frequency;
            const isZeroFrequency = frequency === 0;

            return (
              <button
                key={item.key ?? idx}
                className={`${styles.optionBtn} ${
                  isQuestionnaire ? styles.optionBtnQuestionnaire : ""
                } ${isSelected ? styles?.selected : ""}`}
                onClick={() => !isDisabled && toggle(idx)}
                disabled={
                  isDisabled ||
                  (!isQuestionnaire && isZeroFrequency && !isSelected)
                }
                data-zero-frequency={isZeroFrequency}
                title={item.label}
              >
                {truncateLabel(item.label)}
              </button>
            );
          })}
      </section>
    </FilterBase>
  );
};
